import React from 'react';
import { WalletIcon, ChevronRightIcon, CalendarIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function BalanceSnapshotWidget() {
  const navigate = useNavigate();
  const balanceData = {
    totalBalance: 77467.25,
    upcomingPayout: 45230.8,
    currency: 'MYR',
    lastUpdated: '4 Dec 2025 at 1:38 am SGT',
    payoutDate: '5 Dec 2025'
  };
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-MY', {
      style: 'currency',
      currency: balanceData.currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };
  return <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1635">
      <div className="flex items-center justify-between mb-3" data-id="element-1636">
        <h3 className="text-sm font-semibold text-gray-900 flex items-center" data-id="element-1637">
          <WalletIcon size={16} className="mr-2 text-green-600" data-id="element-1638" />
          Balance
        </h3>
        <button onClick={() => navigate('/balance')} className="text-xs text-blue-600 hover:text-blue-700 font-medium flex items-center" data-id="element-1639">
          View all
          <ChevronRightIcon size={14} className="ml-1" data-id="element-1640" />
        </button>
      </div>

      <p className="text-xs text-gray-500 mb-3" data-id="element-1641">
        Updated on {balanceData.lastUpdated}
      </p>

      <div className="space-y-4" data-id="element-1642">
        {/* Main Balance Display */}
        <div className="pb-4 border-b border-gray-200" data-id="element-1643">
          <div className="text-2xl font-bold text-gray-900" data-id="element-1644">
            {formatCurrency(balanceData.totalBalance)}
          </div>
        </div>

        {/* Upcoming Payout */}
        <div className="bg-blue-50 rounded-lg p-3 border border-blue-100" data-id="element-1645">
          <div className="flex items-start justify-between" data-id="element-1646">
            <div className="flex-1" data-id="element-1647">
              <div className="flex items-center gap-1.5 mb-1" data-id="element-1648">
                <CalendarIcon size={14} className="text-blue-600" data-id="element-1649" />
                <span className="text-xs font-medium text-blue-900" data-id="element-1650">
                  Upcoming payout
                </span>
              </div>
              <div className="text-sm text-blue-700 mb-0.5" data-id="element-1651">
                {formatCurrency(balanceData.upcomingPayout)}
              </div>
              <div className="text-xs text-blue-600" data-id="element-1652">
                {balanceData.payoutDate}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}